import request from 'axios';
import queryString from 'query-string';
import idx from 'idx';
import pick from 'lodash/pick';
import { setBannerError } from 'error';

/* ACTIONS
================================================================================================ */
const TOGGLE_ACTION_CONFIRMATION = 'crowdspring/email_automations/TOGGLE_ACTION_CONFIRMATION';

const TOGGLE_EMAIL_EDITOR = 'crowdspring/email_automations/TOGGLE_EMAIL_EDITOR';

const FETCH_LEAD_COUNT = 'crowdspring/email_automations/FETCH_LEAD_COUNT';
const FETCH_LEAD_COUNT_REQUEST = 'crowdspring/email_automations/FETCH_LEAD_COUNT_REQUEST';
const FETCH_LEAD_COUNT_SUCCESS = 'crowdspring/email_automations/FETCH_LEAD_COUNT_SUCCESS';

const SEND_TEST_EMAIL = 'crowdspring/email_automations/SEND_TEST_EMAIL';

/* HELPERS
================================================================================================ */

/* INITIAL STATES
================================================================================================ */
const initialState = {
  actionConfirmationInfo: null,
  emailInfo: null,
  probableLeadCount: null
};

/* REDUCERS
================================================================================================ */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_ACTION_CONFIRMATION:
      return {
        ...state,
        actionConfirmationInfo: action.info
      };
    case TOGGLE_EMAIL_EDITOR:
      return {
        ...state,
        emailInfo: action.info
      };
    case FETCH_LEAD_COUNT_REQUEST:
      return {
        ...state,
        probableLeadCount: null
      };
    case FETCH_LEAD_COUNT_SUCCESS:
      return {
        ...state,
        probableLeadCount: action.payload
      };
    default:
      return state;
  }
}

export const toggleActionConfirmation = (info) => (dispatch) => {
  return dispatch({
    type: TOGGLE_ACTION_CONFIRMATION,
    info
  });
};

export const toggleEmailEditor = (info) => (dispatch) => {
  return dispatch({
    type: TOGGLE_EMAIL_EDITOR,
    info
  });
};

export const fetchProbableLeadCount = (condition, extraContext) => (dispatch) => {
  // TODO!!!!
  setTimeout(() => dispatch({ type: FETCH_LEAD_COUNT_SUCCESS, payload: (new Date()).getMilliseconds() }), 1000);

  const qs = queryString.stringify({
    entry_condition: condition,
    entry_condition_context: JSON.stringify(extraContext)
  });

  return dispatch({
    type: FETCH_LEAD_COUNT,
    promise: request.get(`/api/v1/email-automations/probable_lead_count/?${qs}`)
  });
};

export const sendTestEmail = (formData, emails) => (dispatch) => {
  /* make sure required fields are present */
  if (!(formData.subject && formData.from_email && formData.from_name)) {
    dispatch(
      setBannerError(
        "Error sending test email",
        'At least "Subject", "Sender email" and "Sender name" must be provided.'
      )
    );
    return Promise.reject();
  }

  const data = {
    emails: (emails || '').split('\n'),
    ...pick(formData, 'subject', 'preheader', 'text_content', 'from_name', 'from_email'),
    html_content: idx(formData, _ => _.html_data.html) || '',
    extra_link_attributes: {
      ...pick(formData, 'utm_source', 'utm_medium', 'utm_name')
    }
  };

  //TODOconst promise = request.post('/api/v1/email-automations/send_test_email/', data);
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => resolve({ data: {} }), 1000);
  })

  promise.catch((err) => {
    const errorMsg = idx(err, _ => _.data.message) || 'Unknown error';
    dispatch(setBannerError('Error sending test email', errorMsg));
  });

  dispatch({
    type: SEND_TEST_EMAIL,
    promise
  });

  return promise;
}



// WEBPACK FOOTER //
// ./email_automations/ducks/common.js